import { render, staticRenderFns } from "./cateredPaymentChannel.vue?vue&type=template&id=f521c9e8&scoped=true&"
import script from "./cateredPaymentChannel.vue?vue&type=script&lang=js&"
export * from "./cateredPaymentChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f521c9e8",
  null
  
)

export default component.exports